/* eslint-disable perfectionist/sort-objects */
export const requestLogResources = {
  IncomeOperation: 'income-operation',
  OutcomeOperation: 'outcome-operation'
};

// Kept in sync with backend/src/router/**/index.js `logRequest(resource, action)`
// registrations and backend/src/constants/request-log.js status maps.
export const requestLogActions = {
  create: 'create',
  createCheck: 'create-check',
  createTransfer: 'create-transfer',
  get: 'get',
  update: 'update',
  updateCards: 'update-cards',
  setApprovedSum: 'set-approved-sum',
  delete: 'delete',
  reopen: 'reopen',
  none: 'none',
  inWork: 'in-work',
  approved: 'approved',
  approvedPartial: 'approved-partial',
  rejected: 'rejected',
  sendToResolve: 'send-to-resolve',
  waitPayment: 'wait-payment',
  paid: 'paid',
  reAssign: 're-assign',
  pause: 'pause',
  canceledByClient: 'canceled-by-client',
  unknown: 'unknown'
};

export const requestLogMethods = ['GET', 'POST', 'PATCH', 'PUT', 'DELETE'];

// Only these are accepted by the backend `sort` param (see
// backend/src/router/admin/request-log/utils.js). Column `key` must match.
export const requestLogSortableFields = [
  'createdAt',
  'durationMs',
  'statusCode',
  'responseSize',
  'path',
  'resource',
  'action'
];

export const requestLogMethodColors = {
  GET: 'blue',
  POST: 'green',
  PATCH: 'gold',
  PUT: 'gold',
  DELETE: 'red'
};

export const getRequestLogResourceOptions = (t) => [
  { label: t('Receipts'), value: requestLogResources.IncomeOperation },
  { label: t('Payouts'), value: requestLogResources.OutcomeOperation }
];

export const getRequestLogActionOptions = (t) =>
  Object.values(requestLogActions).map((value) => ({
    label: t(`requestLogAction.${value}`),
    value
  }));

export const getRequestLogMethodOptions = () =>
  requestLogMethods.map((value) => ({ label: value, value }));

export const getStatusCodeColor = (statusCode) => {
  if (!statusCode) return 'default';
  if (statusCode >= 500) return 'red';
  if (statusCode >= 400) return 'volcano';
  if (statusCode >= 300) return 'gold';
  return 'green';
};

export const getDurationColor = (durationMs) => {
  if (durationMs === null || durationMs === undefined) return undefined;
  if (durationMs >= 3000) return 'var(--red-first)';
  if (durationMs >= 1000) return 'var(--yellow-second)';
  return undefined;
};
